import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '../api.service';
import { HandleFileService } from './handle-file.service';

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  userAuthenticatedSubject = new Subject();
  downloadDocumentsSubject = new Subject();
  trainingResponseSubject = new Subject();
  constructor(private api: ApiService, private handleFile: HandleFileService) { }

  sendMessage(message) {
    return this.api.post(`/api/transactions/send_service_email/`, { 'body': message })
    .pipe(
      map(response => {
        return response;
      })
    );
  }

  downloadTrainingDocs() {
    return this.handleFile.get(`/api/transactions/download/training_docs/`);
  }

  userAuthorized(event) {
    this.userAuthenticatedSubject.next(event);
  }
}
